<template>
  <t-form labelWidth="80px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <CptInputOptionBase :attribute="attribute" :currentCpt="currentCpt" @changeSize="changeSize"/>
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
import CptInputOptionBase from "@/components/element/options/comp/cpt-input-option-base";
export default {
  name: "cpt-phone-number-option",
  props: {
      attribute:Object,
      cptDataForm: Object,
      currentCpt: Object,
  },
  components: { CptData,CptInputOptionBase },
  data() {
    return {
      sizeOptions: {
        small: { width: this.currentCpt.cptWidth, height: 24 },
        medium: { width: this.currentCpt.cptWidth, height: 32 },
        large: { width: this.currentCpt.cptWidth, height: 40 },
      },
    };
  },
  methods: {
    changeSize(val) {
      const sizeAttributes = this.sizeOptions[val];
      if (sizeAttributes) {
        this.attribute.width = sizeAttributes.width;
        this.attribute.height = sizeAttributes.height;
      } else {
        console.warn(`Invalid size option: ${val}`);
      }
    },
  },
};
</script>

<style scoped>
</style>